export enum DonorShieldDirectViewType {
    EditDonor = 0,
    DeleteDonor = 1,
    ApplyWage = 2,
    EditWageAndTravel = 3,
    OrderStreamlinedSerology = 4
}